import React, { useEffect } from 'react'
import Business from '../../Components/ServiceAndWork/Business/Business'
import Contact from '../../Components/Contact/Contact'
import ItSolution from '../../Components/ServiceAndWork/ItSolution/ItSolution'
import Service from '../../Components/ServiceAndWork/Service/Service'
import WorkPage from '../../Components/Work/WorkPage'
import styles from "./ServiceAndWork.module.css"
import side from "../../assets/CircleDraw.png"
import Navbar from '../../Components/Header/Navbar'
import AnimiatedPage from '../../AnimiatedPage'
import Model from '../../Components/model/Model'

function ServiceAndWork() {
  useEffect(()=>{
    document.title = 'SHARVIL Business Group-Services we provide'
    },[])
  return (
    <AnimiatedPage>
      <Model />
      <div className={styles.ServiceAndWork}>
        <h3 className={styles.serviccehead} style={{ color: "#066263" }}>サービス <span>SERVICES</span></h3>

        <Service />

        <ItSolution />
        <div className={styles.leftImage}>
          <img src={side} alt="" />
        </div>
        <Business />


        <WorkPage />


        <Contact />


      </div>
    </AnimiatedPage>
  )
}

export default ServiceAndWork